<template>
	<v-container
		grid-list-xl
	>
        <v-layout
			row
			wrap
			ma-0
			justify-center
			align-center
			class="text-xs-center"
		>
			<v-flex
				xs12
				md8
				ma-0
				pa-0
			>
				<slot name="alert"/>
			</v-flex>
		</v-layout>
		<ArticleIterator
			:items="deletedArticles"
			:isArchive="true"
			@restore="onRestore"
		/>
		<Confirm ref="confirm" />
    </v-container>
</template>

<script>
import ArticleIterator from '@/components/Article/ArticleIterator';
import Confirm from '@/components/Confirm';

export default {
	components: {
		Confirm,
		ArticleIterator,
	},
    computed: {
		deletedArticles() {
			return this.$store.get('deletedArticles');
		},
	},
	methods: {
		onRestore(article) {
			const reportName = this.$store.get('reports/currentReport').displayName;
			this.$refs.confirm.createConfirm(`This will restore "${article.titleText}" in ${reportName}.`, 'success').then((answer) => {
				if (!answer) {
					return;
				}

				article.restore();
			});
		},
	},
}
</script>

<style lang="scss" scoped>

</style>
